/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Speakers_Metrics_Events_SuffixInputs */

const en_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const fr_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const de_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const it_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const ru_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const es_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const zh_cn2_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const ja_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const hi_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

const pt_pt2_speakers_metrics_events_suffix = /** @type {(inputs: Speakers_Metrics_Events_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
};

/**
* | output |
* | --- |
* | "{name} Events" |
*
* @param {Speakers_Metrics_Events_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_events_suffix = /** @type {((inputs: Speakers_Metrics_Events_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Events_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_events_suffix(inputs)
	if (locale === "de") return de_speakers_metrics_events_suffix(inputs)
	if (locale === "it") return it_speakers_metrics_events_suffix(inputs)
	if (locale === "ru") return ru_speakers_metrics_events_suffix(inputs)
	if (locale === "es") return es_speakers_metrics_events_suffix(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_events_suffix(inputs)
	if (locale === "ja") return ja_speakers_metrics_events_suffix(inputs)
	if (locale === "hi") return hi_speakers_metrics_events_suffix(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_events_suffix(inputs)
	return en_speakers_metrics_events_suffix(inputs)
});